import { BaseQueryFn } from "@reduxjs/toolkit/dist/query/react";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { getValueInCookie, removeValueInCookie } from "@admin/utils";

/**
 * @deprecated remove in the future
 */
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const axiosInstance = axios.create({
  withCredentials: true,
  validateStatus: (status) => {
    return status >= 200 && status < 300;
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (
      (config.method == "get" ||
        config.method == "post" ||
        config.method == "put" ||
        config.method == "delete") &&
      !getValueInCookie("XSRF-TOKEN")
    ) {
      return setCSRFToken().then((response) => config);
    }
    return config;
  },
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status == 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      removeValueInCookie("XSRF-TOKEN");
      await setCSRFToken();
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

const setCSRFToken = () => {
  return axios.get("/sanctum/csrf-cookie");
};

interface Params {
  baseUrl: string;
  prepareHeaders?: (headers, props) => any;
}

export interface AxiosBaseQueryParams {
  url: string;
  method: AxiosRequestConfig["method"];
  data?: AxiosRequestConfig["data"];
  params?: AxiosRequestConfig["params"];
}

export interface AxiosSuccessReturnType<T> {
  data: T;
}

export interface AxiosErrorReturnType {
  status: number;
}

export const axiosBaseQuery =
  ({
    baseUrl,
    prepareHeaders,
  }: Params): BaseQueryFn<
    AxiosBaseQueryParams,
    AxiosSuccessReturnType<any>,
    AxiosErrorReturnType
  > =>
  async ({ url, method, data, params }, api, extraOptions) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: prepareHeaders?.(headers, api) ?? headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data,
        },
      };
    }
  };

export const customAxios = axiosInstance;
